import { RootState } from 'typesafe-actions'

export const selectIsExperimentEnabled = (state: RootState, experimentName: string): boolean => {
    const experiment = state.experiment.experiments.find(({ name }) => name === experimentName)

    return experiment?.enabled || false
}
